module.exports = __webpack_public_path__ + "static/img/testimony (14).3ea6cebe.jpg";